import React, { useState } from 'react';
import './ReportUser.css';

function ReportUser({ userId, userName, onReport }) {
  const [showModal, setShowModal] = useState(false);
  const [category, setCategory] = useState('');
  const [details, setDetails] = useState('');
  const [evidenceUrl, setEvidenceUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const categories = [
    { value: 'harassment', label: 'Harassment' },
    { value: 'spam', label: 'Spam' },
    { value: 'fake_profile', label: 'Fake Profile' },
    { value: 'inappropriate_content', label: 'Inappropriate Content' },
    { value: 'scam_fraud', label: 'Scam/Fraud' },
    { value: 'identity_fraud', label: 'Identity Fraud' },
    { value: 'hate_speech', label: 'Hate Speech' },
    { value: 'violence', label: 'Violence/Threats' },
    { value: 'other', label: 'Other' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!category || !details.trim()) {
      setMessage('Please select a category and provide details');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const token = localStorage.getItem('accessToken');
      
      // Build request body - only include evidenceUrl if it has a value
      const requestBody = {
        category,
        details
      };
      
      if (evidenceUrl && evidenceUrl.trim()) {
        requestBody.evidenceUrl = evidenceUrl.trim();
      }
      
      const response = await fetch(`/api/reports/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Report submitted successfully. Our team will review it shortly.');
        setTimeout(() => {
          setShowModal(false);
          setCategory('');
          setDetails('');
          setEvidenceUrl('');
          setMessage('');
          if (onReport) onReport();
        }, 2000);
      } else {
        setMessage(data.error || 'Failed to submit report');
      }
    } catch (error) {
      console.error('Error submitting report:', error);
      setMessage('Failed to submit report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button onClick={() => setShowModal(true)} className="report-btn">
        Report User
      </button>

      {showModal && (
        <div className="report-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="report-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Report {userName}</h2>
              <button onClick={() => setShowModal(false)} className="close-btn">
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit} className="modal-content">
              <p className="info-text">
                Help us keep Belong safe. Your report will be reviewed by our moderation team.
              </p>

              <div className="form-group">
                <label htmlFor="category">Category *</label>
                <select
                  id="category"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  className="form-select"
                  required
                >
                  <option value="">Select a category...</option>
                  {categories.map(cat => (
                    <option key={cat.value} value={cat.value}>
                      {cat.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="details">Details *</label>
                <textarea
                  id="details"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  placeholder="Please provide specific details about what happened..."
                  rows="5"
                  className="form-textarea"
                  required
                  minLength="20"
                />
                <small className="help-text">
                  Minimum 20 characters. Be specific and factual.
                </small>
              </div>

              <div className="form-group">
                <label htmlFor="evidenceUrl">Evidence URL (Optional)</label>
                <input
                  type="url"
                  id="evidenceUrl"
                  value={evidenceUrl}
                  onChange={(e) => setEvidenceUrl(e.target.value)}
                  placeholder="https://example.com/screenshot.png"
                  className="form-input"
                />
                <small className="help-text">
                  Link to screenshot or other evidence (if available)
                </small>
              </div>

              {message && (
                <div className={`message ${message.includes('success') ? 'success' : 'error'}`}>
                  {message}
                </div>
              )}

              <div className="privacy-notice">
                <strong>Privacy Notice:</strong> Your report is confidential. The reported user 
                will not be notified that you reported them.
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="cancel-btn"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit Report'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ReportUser;
